import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ChartType, ChartOptions, ChartDataSets } from 'chart.js';
import { Label, monkeyPatchChartJsLegend, monkeyPatchChartJsTooltip, Color } from 'ng2-charts';

import * as _moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DashboardService } from 'app/core/services/dashboard.service';
import { UiService } from 'app/core/services/ui.service';
const moment = _moment;


@Component({
  selector: 'app-material-chart',
  templateUrl: './material-chart.component.html',
  styleUrls: ['./material-chart.component.scss']
})
export class MaterialChartComponent implements OnInit {

  chartForm: FormGroup;


  public barChartOptions: ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      display: true,
      // labels: {
      //   filter: (legendItem, chartData) => {
      //     return (legendItem?.datasetIndex || 0) <= 0;
      //   } 
      // }
    },
    scales: {
      xAxes: [
        {
          ticks: {
            beginAtZero: true
          }
        }
      ]
    }
  }
  public barChartLabels: Label[] = [];
  public barChartType: ChartType = 'horizontalBar';
  public barChartLegend = true;
  public barChartPlugins = [];
  public barChartColors: Color[] = [
    {
      backgroundColor: 'rgba(30,129,176, 0.8)'
    },
    {
      backgroundColor: 'rgba(226,135,67, 0.8)'
    },
    {
      backgroundColor: 'rgba(234,182,118, 0.8)'
    }
  ];

  public barChartData: ChartDataSets[] = [
    {
      data: [], label: 'Total'
    },
    {
      data: [], label: 'Chargement', hidden: true
    },
    {
      data: [], label: 'Déchargement', hidden: true
    },
  ];


  // const labels = Utils.months({ count: 7 });
  // const data = {
  //   labels: labels,
  //   datasets: [{
  //     axis: 'y',
  //     label: 'My First Dataset',
  //     data: [65, 59, 80, 81, 56, 55, 40],
  //     fill: false,
  //     backgroundColor: [
  //       'rgba(255, 99, 132, 0.2)',
  //       'rgba(255, 159, 64, 0.2)',
  //       'rgba(255, 205, 86, 0.2)',
  //       'rgba(75, 192, 192, 0.2)',
  //       'rgba(54, 162, 235, 0.2)',
  //       'rgba(153, 102, 255, 0.2)',
  //       'rgba(201, 203, 207, 0.2)'
  //     ],
  //     borderColor: [
  //       'rgb(255, 99, 132)',
  //       'rgb(255, 159, 64)',
  //       'rgb(255, 205, 86)',
  //       'rgb(75, 192, 192)',
  //       'rgb(54, 162, 235)',
  //       'rgb(153, 102, 255)',
  //       'rgb(201, 203, 207)'
  //     ],
  //     borderWidth: 1
  //   }]
  // };

  constructor(
    private formBuilder: FormBuilder,
    private dashboardService: DashboardService,
    private translateService: TranslateService,
    public uiService: UiService
  ) {
    monkeyPatchChartJsTooltip();
    monkeyPatchChartJsLegend();
  }

  ngOnInit() {
    const fb = this.formBuilder;
    this.chartForm = fb.group({
      dateBegin: fb.control(moment().add(-30, 'days').toDate(), [Validators.required]),
      dateEnd: fb.control(moment().toDate(), [Validators.required]),
    });

    this.chartForm.controls.dateBegin.valueChanges.subscribe(() => {
      this.onSubmit();
    });
    this.chartForm.controls.dateEnd.valueChanges.subscribe(() => {
      this.onSubmit();
    });
    this.onSubmit();
  }
  onSubmit() {
    this.dashboardService.getDashboardMaterial(moment(this.chartForm.controls.dateBegin.value).format('YYYY-MM-DD'), moment(this.chartForm.controls.dateEnd.value).format('YYYY-MM-DD')).subscribe(data => {
      this.barChartLabels = [];
      this.barChartData[0].data = [];
      this.barChartData[1].data = [];
      this.barChartData[2].data = [];
      data.materialLoading.forEach(materialLoading => {
        this.barChartLabels.push(materialLoading.material.name);
        if (this.barChartData[0].data) {
          this.barChartData[0].data.push(materialLoading.quantity);
        }
        if (this.barChartData[1].data) {
          this.barChartData[1].data.push(materialLoading.quantity);
        }
      });
      data.materialUnloading.forEach(materialUnloading => {
        if (this.barChartLabels.find(f => f == materialUnloading.material.name)) {
          const index = this.barChartLabels.indexOf(materialUnloading.material.name);
          if (this.barChartData[2].data) {
            this.barChartData[2].data[index] = materialUnloading.quantity;
          }
          if (this.barChartData[0].data) {
            this.barChartData[0].data[index] = Number(this.barChartData[0].data[index]) + materialUnloading.quantity;
          }
        } else {
          const index = this.barChartLabels.length;
          this.barChartLabels.push(materialUnloading.material.name);
          if (this.barChartData[2].data) {
            this.barChartData[2].data[index] = materialUnloading.quantity;
          }
          if (this.barChartData[0].data) {
            this.barChartData[0].data[index] = materialUnloading.quantity;
          }
        }
      });
    });
  }
}
